export class Session {
    constructor( 
        public SessionID?: string,
        public ClinicID?: string,
        public MachineID?: string,
        public UserID?: string,
        public PatientID?: string,
        public SettingID?: string,
        public SessionDateTime?: string,
        public TherapyMode?: string,
        public NegativeElapsedTime?: string,
        public TherapyElapsedTime?: string,
        public RecoveryTime?: Number,
        public AverageRecoveryTime?: string,
        public CreatedOn?: Date
    ) {}
}